<template>
  <UIYesNoSwitch
    v-if="settings?.optional"
    v-model="value"
    :label
    :size
    :disabled
    variant="secondary"
    labelYes="This"
    labelNo="None"
    class="mapping-rules-entry-account"
  />
  <div v-else>
    <div class="ui-yes-no-switch__label">
      {{ label }}
    </div>
    <UIButton
      label="This"
      :size
      :disabled
      variant="secondary"
      class="mapping-rules-entry-account__button"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { InputSize, TransactionSettingsAsset } from '@types'
import { MappingRuleActionAccount } from '../utils/types'

import { UIButton } from '@ui/buttons'
import { UIYesNoSwitch } from '@ui/controllers'

type Props = {
  label?: string
  settings?: TransactionSettingsAsset
  disabled?: boolean
}

const props = defineProps<Props>()

const modelValue = defineModel<MappingRuleActionAccount>()

defineOptions({
  inheritAttrs: false,
})

const size = inject<InputSize>('size')

const label = computed(() => props.settings?.title || props.label)

const value = computed({
  get() {
    return !!modelValue.value?.useContextAccount
  },
  set(useContextAccount) {
    modelValue.value = {
      ...modelValue.value,
      useContextAccount,
    }
  },
})
</script>

<style>
.mapping-rules-entry-account {
  & {
    @apply w-full max-w-[10.5rem];
  }

  &__button {
    @apply w-full max-w-[5.25rem];
    @apply pointer-events-none;
  }
}
</style>
